<template>
  <v-card class="mb-4">
    <v-card-title class="text-h3">
      Старые заказы за прошлые дни ({{ itemsLength }})
    </v-card-title>

    <v-card-text>
      <v-data-table
        v-model="selected"
        show-select
        item-key="id"
        :headers="headers"
        :items="items"
        :loading="loading"
        :page="page"
        :items-per-page="itemsPerPage"
        :footer-props="footerProps"
        :server-items-length="itemsLength"
        no-data-text="Висячих заказов нет"
        @update:options="loadItems"
      >
        <!-- eslint-disable-next-line -->
        <template #item.workDay="{ item }">
          {{ formatDate(item.workDay) }}
        </template>

        <!-- eslint-disable-next-line -->
        <template #item.orderStatus="{ item }">
          {{ statusName(item.orderStatus) }}
        </template>

        <!-- eslint-disable-next-line -->
        <template #item.totalPrice="{ item }">
          {{ item.totalPrice | amountWithCurrency0 }}
        </template>

        <!-- eslint-disable-next-line -->
        <template #item.paymentType="{ item }">
          {{ paymentName(item) }}
        </template>
      </v-data-table>

      <div class="mt-4">
        <v-btn
          color="warning"
          class="mr-3"
          :disabled="!selected.length || cancelling"
          @click="openDialog(false)"
        >
          Отменить выбранные ({{ selected.length }})
        </v-btn>
        <v-btn
          color="error"
          :disabled="!itemsLength || cancelling"
          @click="openDialog(true)"
        >
          Отменить все ({{ itemsLength }})
        </v-btn>
      </div>
    </v-card-text>

    <primary-confirm-dialog
      v-model="showDialog"
      title="Отменить заказы?"
      :loading="cancelling"
      @confirm="cancel"
    >
      <template #subtitle>
        Будет отменено заказов: {{ cancelCount }}. Возвраты оплат, чеки и уведомления клиентам
        при этом не отправляются. Действие необратимо.
      </template>
    </primary-confirm-dialog>
  </v-card>
</template>

<script>
  import PrimaryConfirmDialog from '@/components/ui/dialogs/PrimaryConfirmDialog.vue'
  import snackbarMessage from '@/mixins/snackbar-message'
  import OrderStatus from '@/models/enums/OrderStatus'
  import PaymentType from '@/models/enums/PaymentType'
  import filialConnectionApi from '@/api/administration/filialConnection'
  import { formatIsoDateTimeAsDate } from '@/util/date-time-helper'

  export default {
    name: 'FilialConnectionStaleOrdersBlock',
    components: { PrimaryConfirmDialog },
    mixins: [snackbarMessage],
    props: {
      filialId: { type: [Number, String], required: true },
    },
    data () {
      return {
        items: [],
        selected: [],
        loading: false,
        cancelling: false,
        showDialog: false,
        cancelAll: false,
        page: 1,
        itemsPerPage: 25,
        itemsLength: 0,
        footerProps: { 'items-per-page-options': [15, 25, 50, 100] },
        // Сортировка фиксирована на сервере: work_day, затем id
        headers: [
          { text: 'Номер', value: 'formattedCode', sortable: false },
          { text: 'Рабочий день', value: 'workDay', sortable: false },
          { text: 'Статус', value: 'orderStatus', sortable: false },
          { text: 'Сумма', value: 'totalPrice', sortable: false },
          { text: 'Оплата', value: 'paymentType', sortable: false },
        ],
      }
    },
    computed: {
      cancelCount () {
        return this.cancelAll ? this.itemsLength : this.selected.length
      },
    },
    methods: {
      loadItems (options) {
        if (this.page === options.page && this.itemsPerPage === options.itemsPerPage && this.items.length) {
          return
        }

        this.page = options.page
        this.itemsPerPage = options.itemsPerPage

        this.load()
      },
      async load () {
        this.loading = true
        try {
          const response = await filialConnectionApi.fetchStaleOrders(this.filialId, {
            page: this.page,
            limit: this.itemsPerPage,
          })

          this.items = response.items
          this.itemsLength = response.meta.total
          this.itemsPerPage = response.meta.limit
          this.selected = []
        } catch (e) {
          this.showErrorFromResponse(e)
        }
        this.loading = false
      },
      formatDate (value) {
        return formatIsoDateTimeAsDate(value)
      },
      statusName (status) {
        return OrderStatus.getName(status)
      },
      paymentName (item) {
        return PaymentType.getName(item.paymentType, item.deliveryType)
      },
      openDialog (all) {
        this.cancelAll = all
        this.showDialog = true
      },
      async cancel () {
        this.cancelling = true
        try {
          const orderIds = this.cancelAll ? [] : this.selected.map((item) => item.id)
          const res = await filialConnectionApi.cancelStaleOrders(this.filialId, orderIds)
          this.showSuccessMessage(`Отменено заказов: ${res.canceled}`)
          this.page = 1
          await this.load()
          this.$emit('updated')
        } catch (e) {
          this.showErrorFromResponse(e)
        }
        this.cancelling = false
        this.showDialog = false
      },
    },
  }
</script>
